export var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["Year"] = 0] = "Year";
    TimeUnit[TimeUnit["Month"] = 1] = "Month";
    TimeUnit[TimeUnit["Quarter"] = 2] = "Quarter";
    TimeUnit[TimeUnit["Week"] = 3] = "Week";
    TimeUnit[TimeUnit["IsoWeek"] = 4] = "IsoWeek";
    TimeUnit[TimeUnit["Day"] = 5] = "Day";
    TimeUnit[TimeUnit["Hour"] = 6] = "Hour";
    TimeUnit[TimeUnit["Minute"] = 7] = "Minute";
    TimeUnit[TimeUnit["Second"] = 8] = "Second";
})(TimeUnit || (TimeUnit = {}));
export class TimeUnitInfo {
    static toMomentStartOf(timeUnit) {
        switch (timeUnit) {
            case TimeUnit.Year:
                return 'year';
            case TimeUnit.Month:
                return 'month';
            case TimeUnit.Quarter:
                return 'quarter';
            case TimeUnit.Week:
                return 'week';
            case TimeUnit.IsoWeek:
                return 'isoWeek';
            case TimeUnit.Day:
                return 'day';
            case TimeUnit.Hour:
                return 'hour';
            case TimeUnit.Minute:
                return 'minute';
            case TimeUnit.Second:
                return 'second';
        }
    }
}
//# sourceMappingURL=TimeUnit.js.map